import { useEffect } from 'react';

export default function App() {
  // 跳轉函數
  const Redirect = () => {
    window.location.href = "tmp.html";
  };

  return (
    <>
      <style>{`
        .public-name {
          padding: 3px 6px;
          border-radius: 6px;
          font-weight: bold;
          color: #fff;
        }
        .content .content_cn p{
          font-size: 16px;
        }
        .red {
          color: red;
        }
        .zoomtxt {
          animation: zoomInOut 1s infinite alternate ease-in-out;
        }
        @keyframes zoomInOut {
          0% {
            transform: scale(0.95);
          }
          100% {
            transform: scale(1);
          }
        }
        /* ========== 補上圖片核心樣式（解決圖片撐滿變大問題） ========== */
        .button-cart img {
          width: 100%;
          height: auto;
          display: block;
          border-radius: 4px;
        }
        .avatar-img {
          width: 40px;
          height: 40px;
          object-fit: cover;
        }
        .icon-small {
          width: 27px;
          height: 18px;
          object-fit: contain;
        }
        .gg-01 {
          padding:12px;
          background:#f7f7f7;
          border-radius:8px;
          margin:6px 0;
        }
        .gg-02 {
          height:8px;
        }
        .gg-03 {
          font-weight:bold;
          margin-left:8px;
        }
        .Jh_tx {
          display:flex;
          align-items:center;
          gap:6px;
          margin:16px 0;
        }
      `}</style>

      <div data-cz-shortcut-listen="true">
        <div id="flow_znwx">
          <p id="znwx_icon"></p>
          <div id="znwx_copybg"></div>
          <div id="znwx_copy">
            <p id="close_znwx"></p>
          </div>
        </div>

        <div className="content">
          <div align="center">
            <p className="css11">
              <strong style={{ color: '#000', fontSize: '26px' }}>
                "賺錢有什麼不對？朱家泓從父親那裡習得了他的投資哲學。"
              </strong>
            </p>
            <br />
            <hr />
          </div>

          <div className="content_top"></div>
          <div className="content_cn" data-deep="1">
            <p>
              <a href="#!" className="button-cart lineadd" onClick={Redirect}>
                <img src="static/picture/q1.png" alt="" />
              </a>
            </p>
            <p><b>挑選股票並開展深入研究。精通這些便是成功的秘訣</b></p>
            <p>在當今這個大量貨幣投入流通的世界裡，通膨每年上漲 2% 並不令人意外。這代表 35 年後物價將會翻倍，而貨幣價值會縮減一半</p>
            <p>只把錢存在銀行的人，與積極打理自身資產的人之間，經濟差距正在擴大；我們如今身處一個靜止不動就會錯過大量機會的時代</p>
            <h2 align="center" className="css33 zoomtxt">
              <strong>
                <a href="#!" className="button-cart lineadd to_link" onClick={Redirect}>
                  點擊加朱家泓的LINE領取飆股
                </a>
              </strong>
            </h2>
            <p>投資股票具有高報酬的潛力。股價通常會隨著企業獲利的成長而上漲，投資人既可從股價增值中獲利，也能享有股息收益。</p>
            <p>股票市場提供多元化的投資機會，有助於投資人分散資產配置，進而降低風險。</p>

            <div style={{ backgroundColor: '#faebd7', textAlign: 'center' }}>
              <p>
                <a
                  href="#!"
                  style={{ textDecorationLine: 'none', color: '#7bbd21' }}
                  onClick={Redirect}
                >
                  "2026年翻百倍的股票 – 立即獲取分析報告！"
                </a>
              </p>
            </div>

            <p>
              <a href="#!" className="button-cart lineadd" onClick={Redirect}>
                <img src="static/picture/q2.jpg" alt="" />
              </a>
            </p>

            <h2 align="center" className="css33 zoomtxt">
              <strong>
                <a href="#!" className="button-cart lineadd to_link" onClick={Redirect}>
                  點擊加朱家泓的LINE領取飆股
                </a>
              </strong>
            </h2>

            <p>我們鄭重聲明：不收取任何手續費。我們只想幫助您，避免您在這場無聲的戰爭中成為受害者。在股票市場中，隨著時間推移可以累積許多經驗，但經驗並不一定就是成功的祕訣。我的一位朋友想學習買股票，以便從虧損轉為獲利，但他不知道在當前的經濟環境下該如何應對。他表示想幫助更多人實現財務自由，因此決定舉辦股票投資活動。我們提供免費的股票知識課程，任何對股票投資有興趣的人都可以參加。</p>
            <p>透過本課程，您將學到投資方法、如何挑選高股息股票，以及如何精準預測未來股市趨勢。憑藉超過30年的投資教學經驗，目前的準確率高達98.8%。需要強調的是，這是一門完全免費的課程。</p>

            <h2 align="center" className="css33 zoomtxt">
              <strong>
                <a href="#!" className="button-cart lineadd to_link" onClick={Redirect}>
                  點擊加朱家泓的LINE領取飆股
                </a>
              </strong>
            </h2>

            <p>
              <a href="#!" className="button-cart lineadd" onClick={Redirect}>
                <img src="static/picture/q3.jpg" alt="" />
              </a>
            </p>
            <p>儘管這聽起來可能有些不切實際，但這個方法已幫助許多人學會了正確的賺錢之道。它的有效性已獲得近20年的實證考驗，你也同樣可以付諸實行。現在就加入我們吧：我們將免費為你提供股票投資的資訊與建議。我們只談股票——歡迎加入我們的群組！</p>

            <h2 align="center" className="css33 zoomtxt">
              <strong>
                <a href="#!" className="button-cart lineadd to_link" onClick={Redirect}>
                  點擊加朱家泓的LINE領取飆股
                </a>
              </strong>
            </h2>
          </div>

          <div className="content_Js">
            <br />
            <div className="Jh_tx">
              <div className="Jh yii_template" type="text" name="">
                <img src="static/picture/icon1.png" alt="" />
                <span>精選評論</span>
              </div>
            </div>
            <div>
              <div className="gg-02"></div>
              <div style={{ margin: '10px 0px 0px 0px' }}>
                <div>
                  <img className="avatar-img b-lazy b-loaded" src="static/picture/w1.png" alt="" />
                  <span className="gg-03">陳南廷</span>
                  <span style={{ width: '20px', height: '18px', position: 'relative', bottom: '25px', left: '18px', display: 'inline-block', fontSize: '10px', textAlign: 'center', color: '#FFF' }}>6</span>
                  <span style={{ position: 'relative', float: 'right' }}>
                    <img className="icon-small b-lazy b-loaded" src="static/picture/icon2.png" alt="" />
                  </span>
                </div>
                <div className="gg-01">果然不出所料，這位老師非常專業。（一位擁有9年股票交易經驗者的個人看法）</div>
                <div className="gg-02"></div>
                <div style={{ margin: '10px 0px 0px 0px' }}>
                  <div>
                    <img className="avatar-img b-lazy b-loaded" src="static/picture/w2.png" alt="" />
                    <span className="gg-03">鄒瑋駿</span>
                    <span style={{ width: '20px', height: '18px', position: 'relative', bottom: '25px', left: '18px', display: 'inline-block', fontSize: '10px', textAlign: 'center', color: '#FFF' }}>1</span>
                    <span className="gg-04"></span>
                    <span style={{ position: 'relative', float: 'right' }}>
                      <img className="icon-small b-lazy b-loaded" src="static/picture/icon2.png" alt="" />
                    </span>
                  </div>
                  <div className="gg-01">自從加了老師的LINE之後，我把之前一直賣不掉的股票順利出清，重新調整了投資組合，終於獲利了！</div>
                  <div className="gg-02"></div>
                  <div style={{ margin: '10px 0px 0px 0px' }}>
                    <div>
                      <img className="avatar-img b-lazy b-loaded" src="static/picture/w3.png" alt="" />
                      <span className="gg-03">王麗秋</span>
                      <span style={{ width: '20px', height: '18px', position: 'relative', bottom: '19px', left: '18px', display: 'inline-block', fontSize: '10px', textAlign: 'center', color: '#FFF' }}>6</span>
                      <span className="gg-04"></span>
                      <span style={{ position: 'relative', float: 'right' }}>
                        <img className="icon-small b-lazy b-loaded" src="static/picture/icon2.png" alt="" />
                      </span>
                    </div>
                    <div className="gg-01">我投資股票已經有一段時間了，但始終找不到正確的方法。請告訴我該如何正確投資。到目前為止，我都還沒有任何獲利……</div>
                    <div className="gg-02"></div>
                    <div style={{ margin: '10px 0px 0px 0px' }}>
                      <div>
                        <img className="avatar-img b-lazy b-loaded" src="static/picture/w4.png" alt="" />
                        <span className="gg-03">水來伯</span>
                        <span style={{ width: '20px', height: '18px', position: 'relative', bottom: '19px', left: '18px', display: 'inline-block', fontSize: '10px', textAlign: 'center', color: '#FFF' }}>6</span>
                        <span className="gg-04"></span>
                        <span style={{ position: 'relative', float: 'right' }}>
                          <img className="icon-small b-lazy b-loaded" src="static/picture/icon2.png" alt="" />
                        </span>
                      </div>
                      <div className="gg-01">跟老師學習後，我在第一週就賺了700萬臺幣。我覺得即使是完全沒有經驗的初學者，也能成為投資高手！</div>
                      <div className="gg-02"></div>
                      <div style={{ margin: '10px 0px 0px 0px' }}>
                        <div>
                          <img className="avatar-img b-lazy b-loaded" src="static/picture/w5.png" alt="" />
                          <span className="gg-03">陳彩蓮</span>
                          <span style={{ width: '20px', height: '18px', position: 'relative', bottom: '19px', left: '18px', display: 'inline-block', fontSize: '10px', textAlign: 'center', color: '#FFF' }}>11</span>
                          <span className="gg-04"></span>
                          <span style={{ position: 'relative', float: 'right' }}>
                            <img className="icon-small b-lazy b-loaded" src="static/picture/icon2.png" alt="" />
                          </span>
                        </div>
                        <div className="gg-01">
                          你的建議精準得令人難以置信。你懂得分析每個人的具體狀況！上週你對股市的預測完全準確，所以我進行了投資。從那時起，我的收益一直很穩定。我感到非常高興。謝謝你！知道女性也能成為成功的投資者，真是太好了。
                          <p style={{ fontSize: '14px' }}>
                            <span className="gg-05"></span>
                          </p>
                        </div>
                        <div className="gg-02"></div>
                        <div style={{ margin: '10px 0px 0px 0px' }}>
                          <div>
                            <img className="avatar-img b-lazy b-loaded" src="static/picture/w6.jpg" alt="" />
                            <span className="gg-03">許連統</span>
                            <span style={{ width: '20px', height: '18px', position: 'relative', bottom: '25px', left: '18px', display: 'inline-block', fontSize: '10px', textAlign: 'center', color: '#FFF' }}>1</span>
                            <span className="gg-04"></span>
                            <span style={{ position: 'relative', float: 'right' }}>
                              <img className="icon-small b-lazy b-loaded" src="static/picture/icon2.png" alt="" />
                            </span>
                          </div>
                          <div className="gg-01">
                            在投資市場中，我始終是個新手，一直不希望自己成為被收割的對象。感謝你的分享，讓我受益良多！
                            <p style={{ fontSize: '14px' }}>
                              <span className="gg-05"></span>
                            </p>
                          </div>
                          <div className="gg-02"></div>
                          <div style={{ margin: '10px 0px 0px 0px' }}>
                            <div>
                              <img className="avatar-img b-lazy b-loaded" src="static/picture/w7.jpg" alt="" />
                              <span className="gg-03">陸秀枝</span>
                              <span style={{ width: '20px', height: '18px', position: 'relative', bottom: '19px', left: '18px', display: 'inline-block', fontSize: '10px', textAlign: 'center', color: '#FFF' }}>5</span>
                              <span className="gg-04"></span>
                              <span style={{ position: 'relative', float: 'right' }}>
                                <img className="icon-small b-lazy b-loaded" src="static/picture/icon2.png" alt="" />
                              </span>
                            </div>
                            <div className="gg-01">剛開始我還以為他只會紙上談兵，沒想到實戰操作也這麼厲害。能當他的學生真的超幸運的。他是一位真正看透市場的老師。</div>
                            <div style={{ fontSize: '12px', padding: '20px', fontWeight: 500 }}>
                              本網站所提供之資訊僅作為一般參考及教育用途。對於本站內容之完整性、時效性及正確性，我們不負任何保證責任。
                              <br />
                              本網站對所提供資訊之完整性、時效性及正確性不負任何保證責任。所有數據僅供投資決策參考之用，本公司不承擔任何投資所生之損益責任，亦不保證任何最低報酬。謹此提醒，前述資訊僅為參考性質，實際投資績效將因個人投資條件與市場變化而異。
                            </div>
                            <br /><br /><br />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}